import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 q-pa-sm recent-orders" }
const _hoisted_3 = { class: "col-12 q-pa-sm" }
const _hoisted_4 = { class: "col-12 q-pa-sm" }
const _hoisted_5 = { class: "row justify-center q-my-md" }
const _hoisted_6 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_supplier_catalogue_stock_items = _resolveComponent("supplier-catalogue-stock-items")!
  const _component_supplier_catalogue_recent_orders = _resolveComponent("supplier-catalogue-recent-orders")!
  const _component_supplier_catalogue_settings = _resolveComponent("supplier-catalogue-settings")!
  const _component_supplier_catalogue_sync_settings = _resolveComponent("supplier-catalogue-sync-settings")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_supplier_catalogue_stock_items, {
      key: _ctx.supplierCatalogue.sys.id.toString(),
      supplierCatalogue: _ctx.supplierCatalogue
    }, null, 8, ["supplierCatalogue"])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_supplier_catalogue_recent_orders, {
          catalogue: _ctx.supplierCatalogue.sys.id
        }, null, 8, ["catalogue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_supplier_catalogue_settings, {
          "supplier-catalogue": _ctx.supplierCatalogue,
          "onUpdate:supplierCatalogue": _ctx.handleUpdateSupplierCatalogue
        }, null, 8, ["supplier-catalogue", "onUpdate:supplierCatalogue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_supplier_catalogue_sync_settings, {
          "supplier-catalogue": _ctx.supplierCatalogue,
          "onUpdate:supplierCatalogue": _cache[0] || (_cache[0] = (supCatId, payload) => _ctx.$emit('update:supplier-catalogue', supCatId, payload))
        }, null, 8, ["supplier-catalogue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_btn, {
          class: "error",
          outline: "",
          rounded: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete'))),
          color: "error"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_trash_icon, { left: "" }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Remove Supplier Catalogue", -1))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}